// The logout after inactivity (shared/components/Session/IdleLogout.js): a
// warning after IDLE_MS without activity, the logout COUNTDOWN_MS later.
//
// The time of the last activity is kept in localStorage, so all tabs of the
// site share it: activity in one keeps every tab logged in, and a timer the
// browser slowed down in a background tab still logs out on time. A session
// left alone for longer (the tab closed, the computer asleep) ends when the
// site is opened again (App.js). Time spent paying at Stripe doesn't count.

export const IDLE_MS = 5 * 60 * 1000;
export const COUNTDOWN_MS = 60 * 1000;
export const TIMEOUT_MS = IDLE_MS + COUNTDOWN_MS;

export const ACTIVITY_KEY = "lastActivity";
const AWAY_KEY = "awayAtStripe";
const AWAY_MS = 30 * 60 * 1000; // how long a payment at Stripe may take
const REASON_KEY = "logoutReason";

const readTime = (key) => {
  const value = Number(localStorage.getItem(key));
  return Number.isFinite(value) && value > 0 ? value : null;
};

export const lastActivity = () => readTime(ACTIVITY_KEY);
export const markActivity = (now = Date.now()) => localStorage.setItem(ACTIVITY_KEY, String(now));
export const clearActivity = () => localStorage.removeItem(ACTIVITY_KEY);

// Checkout and the billing portal leave the site; the time there isn't idle
export const markAwayAtStripe = (now = Date.now()) => localStorage.setItem(AWAY_KEY, String(now));
export const clearAwayAtStripe = () => localStorage.removeItem(AWAY_KEY);
export const awayAtStripe = (now = Date.now()) => {
  const since = readTime(AWAY_KEY);
  return since != null && now - since < AWAY_MS;
};

// Why the session ended, for the notice on the logged-out pages
export const setLogoutReason = (reason) => localStorage.setItem(REASON_KEY, reason);
export const logoutReason = () => localStorage.getItem(REASON_KEY);
export const clearLogoutReason = () => localStorage.removeItem(REASON_KEY);

// { phase: "active" | "warning" | "expired", remaining: ms until the logout }
export function idleState(now = Date.now(), last = lastActivity()) {
  if (last == null) return { phase: "active", remaining: TIMEOUT_MS };
  const idle = Math.max(0, now - last);
  if (idle < IDLE_MS) return { phase: "active", remaining: TIMEOUT_MS - idle };
  if (idle < TIMEOUT_MS) return { phase: "warning", remaining: TIMEOUT_MS - idle };
  return { phase: "expired", remaining: 0 };
}

// "1:00", "0:42"
export const clock = (ms) => {
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
};

// "6 minutes", "1 minute"
export const minutes = (ms) => {
  const n = Math.round(ms / 60000);
  return `${n} minute${n === 1 ? "" : "s"}`;
};
